import RateDisplay from "@components/Cards/RateDisplay";
import { useFormatContext } from "@lib/hooks/format-context";
import { getCorrelation } from "./calculations";

type Props = {
  value?: number | null;
  comparedValue?: number | null;
  compared?: boolean;
};

export default function OptionalCurrencyTableDisplay({
  value,
  comparedValue,
  compared,
}: Props) {
  const { calculateCurrencyConvertion } = useFormatContext();
  const hasValue = typeof value === "number" && Number.isFinite(value);
  const hasComparedValue =
    typeof comparedValue === "number" && Number.isFinite(comparedValue);
  const currentDisplay = hasValue ? calculateCurrencyConvertion(value, 2) : "-";

  if (!compared) return <p data-display="currency">{currentDisplay}</p>;
  if (!hasValue && !hasComparedValue) return "-";

  const rate =
    hasValue && hasComparedValue
      ? getCorrelation(value, comparedValue, 2)
      : undefined;

  return (
    <div className="flex items-center w-full">
      <div className="flex-1">
        <p data-display="currency">{currentDisplay}</p>
        <p
          className="text-[11px] leading-tight opacity-70"
          data-display="currency"
          data-compared={true}
        >
          vs{" "}
          {hasComparedValue
            ? calculateCurrencyConvertion(comparedValue, 2)
            : "-"}
        </p>
      </div>
      {rate !== undefined && (
        <RateDisplay rate={rate} isIncreasing={rate < 0} size="small" />
      )}
    </div>
  );
}
